<template>
  <el-dialog v-bind="$attrs"
             v-on="$listeners"
             title="海尔生物医疗经销商引入评估"
             append-to-body
             :close-on-click-modal="false"
             width="90%">
    <div class="h-content paddingtopcls">
      <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;margin-top: 30px;">
        <h1>引入评估</h1>
      </div>
      <div>
        <table style ="border-collapse: collapse;width:80%; margin-bottom: 20px ;margin-top: 20px;margin-left: 60px;" cellspacing =0 border="1">
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" rowspan = "3"><img
                src="../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
            <td style="width: 180px" colspan = "2" rowspan = "3" class="title">海尔生物医疗经销商引入评估</td>
            <td style="width: 100px" >编号：GNSCB-02-F01</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">版本：B</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">页次：1/1</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" colspan = "4" class="subheading">基础信息</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">区    域 </td>
            <td style="width: 180px">{{baseInfo.areaname}}</td>
            <td style="width: 100px">申请日期</td>
            <td style="width: 100px">{{baseInfo.creationDate}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">公司名称</td>
            <td style="width: 180px">{{baseInfo.username}}</td>
            <td style="width: 100px">法人代表</td>
            <td style="width: 100px">{{baseInfo.legal}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">对接人</td>
            <td style="width: 180px">{{baseInfo.name1}}</td>
            <td style="width: 100px">联系电话</td>
            <td style="width: 100px">{{baseInfo.contactmobilephone}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">对阵地市（个数）</td>
            <td style="width: 180px">{{baseInfo.againstAreaCount}}</td>
            <td style="width: 100px">对阵用户（个数）</td>
            <td style="width: 100px">{{baseInfo.againstUserCount}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" colspan = "4" class="subheading">引入评估项目</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">评估项目</td>
            <td style="width: 180px" class="subheading">项目描述</td>
            <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
            <td style="width: 100px" class="subheading">合格/不合格</td>
          </tr>
          <!-- =========动态渲染当前公司评估项目 ========= -->
          <tr v-for="(item, idx) in currentCompany.items" :key="idx" style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px">{{item.name}}</td>
            <td style="width: 180px">{{item.desc}}</td>
            <td style="width: 100px">{{item.evidence}}</td>
            <td style="width: 100px">
              <el-select v-model="currentScore[item.field]" placeholder="请选择" @change="getConclusion" style="width:100px;border: none;box-shadow: none">
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
              </el-select>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">结论</td>
            <td style="width: 180px" colspan="3">{{currentScore.conclusion}}</td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
            <td style="width: 100px" class="subheading">申请请示报告</td>
            <td style="width: 100px" colspan="3">
              <brupload
                  :refid="refid"
                  :reftype="currentReportRefType"
                  uploadflag
                  delflag
                  :before-upload="beforeUpload"
                  :showtime="false"
              >
              </brupload>
            </td>
          </tr>
          <tr style="background-color: White; text-align: center; color:black;height:30px;">
            <td style="width: 100px" class="subheading">网络运营经理确认</td>
            <td style="width: 180px">{{baseInfo.quyuConfirm}}</td>
            <td style="width: 100px" class="subheading">省区经理确认</td>
            <td style="width: 100px" colspan="2">{{baseInfo.daquConfirm}}</td>
          </tr>
        </table>
        <div class="h-pieceIn2">
          <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
            <h1>上传附件</h1>
          </div>
          <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
            上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!
          </div>
          <div class="h-formLine">
            <div class="h-pieceCon2 weekplandetail30">
              <el-form :model="currentScore"
                       ref="formLabelAlign1i"
                       :inline="true" :rules="rules" style="margin-left: 100px">
                <!-- =========动态渲染当前公司附件 ========= -->
                <el-form-item v-for="(up,idx) in currentCompany.uploads"
                              :key="idx"
                              :label="up.label"
                              class="h-elformWrap-2"
                              :prop="up.prop">
                  <brupload
                      :refid="refid"
                      :reftype="up.reftype"
                      :uploadflag="false"
                      :delflag="false"
                      :before-upload="beforeUpload"
                      :showtime="false"
                      :tpFlag = 'true'
                  >
                  </brupload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="center" style="margin-left: 400px;margin-top: 50px">
          <el-button class="h-btn h-formBtn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="choose1">导出Excel
          </el-button>
        </div>
        <div style="height: 50px"> </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ss from '../../api/SystemService'
import {genGraph} from '@/views/process/graph/Graph';
import mxgraph from '@/views/process/graph/index';
import agentCopyService from "../../api/loud/agent/agentCopyService";
import updownfile from "../../utils/updownfile";
import uploadFile from "../../api/process/account_complainUploadService";

export default {
  data() {
    return {
      showTaskList:false,
      usercode:"",
      // 基础信息（公共，所有公司共用）
      baseInfo:{
        usercode:"",
        customerName1:"",
        daquConfirm:"",
        quyuConfirm:"",
        areaname:"",
        creationDate:"",
        username:"",
        legal:"",
        name1:"",
        contactmobilephone:"",
        againstAreaCount:"",
        againstUserCount:"",
      },
      // 【核心】每个公司的评分数据缓存，key=currentCompanyKey
      scoreCache: {},
      refid: null,
      guancha:false,
      isQualified:false,
      inst:{
        daqu:"",
        quyu:"",
      },
      rules: {
        upload1: [{required: true, message: '请上传资料', trigger: 'blur'}],
        upload2: [{required: true, message: '请上传资料', trigger: 'blur'}],
        upload3: [{required: true, message: '请上传资料', trigger: 'blur'}],
        upload4: [{required: true, message: '请上传资料', trigger: 'blur'}],
      },
    };
  },
  computed: {
    UsercodeInfo:function(){
      return this.usercodeInfo;
    },
    Instid:function(){
      return this.instid;
    },
    // 当前公司配置
    currentCompany(){
      const findItem = this.evaluateCompanyList.find(item=> item.key === this.currentCompanyKey)
      if(!findItem){
        return {items:[],uploads:[]}
      }
      return findItem
    },
    // 当前公司评分对象，自动从缓存取
    currentScore(){
      const key = this.currentCompanyKey
      if(!this.scoreCache[key]){
        this.$set(this.scoreCache, key, {
          staffing:"",
          scale:"",
          qualification:"",
          brandPower:"",
          businessPower:"",
          conclusion:"",
          field:""
        })
      }
      return this.scoreCache[key]
    },
    // 申请请示报告reftype：生物医疗用原始，其他加前缀
    currentReportRefType(){
      if(this.currentCompanyKey === 'biomed'){
        return '申请请示报告'
      }
      return this.currentCompanyKey + '_申请请示报告'
    }
  },
  props: {
    usercodeInfo: {
      type: String,
    },
    instid: {
      type: String,
    },
    currentCompanyKey:{
      type:String,
      default:""
    },
    evaluateCompanyList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  watch:{
    // 切换公司，加载数据
    currentCompanyKey(newVal){
      if(newVal){
        this.loadAgentData()
      }
    }
  },
  mounted() {
    if(this.currentCompanyKey){
      this.loadAgentData()
    }
  },
  methods: {
    loadAgentData(){
      ss.SignService.queryAgent(this.UsercodeInfo).then(res => {
        console.log("11111",res)
        // 基础信息统一赋值
        this.baseInfo.usercode= res.obj.usercodeInfo;
        this.baseInfo.customerName1= res.obj.customerName1Bas;
        this.baseInfo.daquConfirm= res.obj.daquConfirmSco;
        this.baseInfo.quyuConfirm= res.obj.quyuConfirmSco;
        this.baseInfo.areaname= res.obj.areanameInfo;
        this.baseInfo.creationDate= res.obj.creationDateBas;
        this.baseInfo.username= res.obj.usernameInfo;
        this.baseInfo.legal= res.obj.legalBas;
        this.baseInfo.name1= res.obj.name1Bas;
        this.baseInfo.contactmobilephone= res.obj.contactmobilephoneBas;
        this.refid = res.obj.fileidInfo;

        // 赋值到当前公司独立缓存
        const s = this.currentScore
        s.staffing = res.obj.staffingSco
        s.scale = res.obj.scaleSco
        s.qualification = res.obj.qualificationSco
        s.brandPower = res.obj.brandPowerSco
        s.businessPower = res.obj.businessPowerSco
        s.conclusion = res.obj.conclusionSco
        s.field = res.obj.fieldSco

        this.getConclusion();
      })
      let query={
        agentCode:this.UsercodeInfo,
      }
      ss.annualTargetApi.selectUserByAgent(query).then(res =>{
        this.baseInfo.againstAreaCount = res.obj;
      })
      ss.annualTargetApi.selectUserByUser(query).then(res =>{
        this.baseInfo.againstUserCount = res.obj;
      })
    },
    ok(){
      this.usercode = this.UsercodeInfo
    },
    getConclusion(){
      const items = this.currentCompany.items || []
      let allPass = true
      for(let item of items){
        const val = this.currentScore[item.field]
        if(val != 1){
          allPass = false
          break
        }
      }
      if(allPass){
        this.currentScore.conclusion = "合格";
        this.isQualified = true;
      }else {
        this.currentScore.conclusion = "不合格";
        this.isQualified = false;
      }
    },
    saveOrUpdate(){
      const items = this.currentCompany.items || []
      // 校验当前公司评估项
      for(let item of items){
        const val = this.currentScore[item.field]
        if(val == null || val === ""){
          this.$message({
            message: "请完善评审项目!",
            type: 'error'
          });
          return;
        }
      }
      // 组装传给后端的参数：基础信息 + 当前公司评分
      let query = { ...this.baseInfo, ...this.currentScore };
      ss.SignService.updateByIdScore(query).then(res =>{
        if(res.f){
          this.$message({
            message: "保存成功!",
            type: 'success'
          });
        }
        this.$emit('choseObj', query)
      })
      this.getConclusion();
    },
    choose1() {
      const exportData = { ...this.baseInfo, ...this.currentScore }
      updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel',exportData,"post");
    },
    beforeUpload(file){
      const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;
      console.log(isFile,file.type)
      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件的大小不能超过 5M!');
        return false;
      }
    },
  }
}
</script>

<style>
.showflowDialogcls .el-dialog__body{
  padding-top: 0px!important;
}
::v-deep  .select{
  border: none;
  box-shadow: none;
}
</style>
<style scoped>
#graphContainer {
  overflow: hidden;
  width: 100%;
  min-height: 100px;
  padding-bottom: 20px;
  background: url('../../assets/images/flow/grid.gif');;
  border-radius: 4px;
}
.h-content {
  padding: 0rem 0.1rem 0 0.1rem;
}
.h-row .h-rowIn {
  padding: 0px !important;
}
.showTaskListClass {
  width:400px;
  border:1px solid #ccc;
  position: fixed;
  color:#333;
  font-size: 12px;
  z-index: 9999;
  background-color: rgba(255,255,255,0.8);
  border: 1px solid #c2c2c2;
  border-radius: 5px;
  padding: 12px;
}
.showTaskListClass  table {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}
.showTaskListClass table thead th{
  background-color: #57aefe;
  text-align: center;
  color:#fff;
}
.showTaskListClass table td, table th {
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
.showTaskListClass table tr:nth-child(odd) {
  background: #fff;
}
.showTaskListClass table tr:nth-child(even) {
  background: #F5FAFA;
}
.outTimeline {
  background-color: #fcfcfc;
  border-radius: 10px;
}
.title{
  font-size: 20px;
  font-weight:bold;
}
.subheading{
  font-weight:bold;
}
</style>
